// // src/pages/configuracoes/PainelEmail.tsx
// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Container, Card, Button, Form,
//   Row, Col, Spinner, Table
// } from 'react-bootstrap';
// import {
//   FaSave, FaEnvelope, FaCog, FaClock,
//   FaBell, FaCheckCircle, FaInfoCircle, FaPlay, FaEye, FaUndo, FaServer, FaLock
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// // ══════════════════════════════════════════════════════
// // TIPOS
// // ══════════════════════════════════════════════════════
// interface EmailConfig {
//   batchSendEnabled:       boolean;
//   sendHour:               number;
//   sendMinute:             number;
//   delayMinSeconds:        number;
//   delayMaxSeconds:        number;
//   // SMTP
//   smtpHost:               string;
//   smtpPort:               number;
//   smtpUser:               string;
//   smtpPassword:           string;
//   smtpFromName:           string;
//   smtpFromEmail:          string;
//   // Antes do vencimento
//   beforeDueEnabled:       boolean;
//   beforeDueDaysMin:       number;
//   beforeDueDaysMax:       number;
//   beforeDueSubject:       string;
//   beforeDueMessage:       string;
//   // Vence hoje
//   dueTodayEnabled:        boolean;
//   dueTodaySubject:        string;
//   dueTodayMessage:        string;
//   // Após vencimento
//   afterDueEnabled:        boolean;
//   afterDueDaysMin:        number;
//   afterDueDaysMax:        number;
//   afterDueSubject:        string;
//   afterDueMessage:        string;
//   // Confirmação
//   paymentConfirmEnabled:  boolean;
//   paymentConfirmSubject:  string;
//   paymentConfirmMessage:  string;
// }

// interface PreviewItem {
//   cliente: string;
//   email:   string;
//   assunto: string;
// }

// // ══════════════════════════════════════════════════════
// // VARIÁVEIS DISPONÍVEIS
// // ══════════════════════════════════════════════════════
// const VARIABLES = [
//   { key: '{{CLIENTE}}',         label: 'Nome do cliente'     },
//   { key: '{{EMPRESA}}',         label: 'Nome da empresa'     },
//   { key: '{{FATURA}}',          label: 'Descrição da fatura' },
//   { key: '{{VENCIMENTO}}',      label: 'Data de vencimento'  },
//   { key: '{{DIAS}}',            label: 'Quantidade de dias'  },
//   { key: '{{VALOR_FATURA}}',    label: 'Valor da fatura'     },
//   { key: '{{LINK_BOLETO}}',     label: 'Link do boleto'      },
//   { key: '{{PIX_COPIA_COLA}}',  label: 'Pix copia e cola'    },
//   { key: '{{LINHA_DIGITAVEL}}', label: 'Linha digitável'     },
// ];

// // ══════════════════════════════════════════════════════
// // ESTADO INICIAL
// // ══════════════════════════════════════════════════════
// const INITIAL_CONFIG: EmailConfig = {
//   batchSendEnabled:      false,
//   sendHour:              9,
//   sendMinute:            0,
//   delayMinSeconds:       10,
//   delayMaxSeconds:       60,
//   smtpHost:              'smtp.gmail.com',
//   smtpPort:              587,
//   smtpUser:              '',
//   smtpPassword:          '',
//   smtpFromName:          '',
//   smtpFromEmail:         '',
//   beforeDueEnabled:      false,
//   beforeDueDaysMin:      1,
//   beforeDueDaysMax:      3,
//   beforeDueSubject:      'Lembrete: seu boleto vence em {{DIAS}} dias',
//   beforeDueMessage:      'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} vence em {{DIAS}} dias ({{VENCIMENTO}}).\n\n',
//   dueTodayEnabled:       false,
//   dueTodaySubject:       'Atenção: seu boleto vence hoje!',
//   dueTodayMessage:       'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} vence hoje ({{VENCIMENTO}}).\n\n',
//   afterDueEnabled:       false,
//   afterDueDaysMin:       1,
//   afterDueDaysMax:       15,
//   afterDueSubject:       'Boleto em atraso há {{DIAS}} dias',
//   afterDueMessage:       'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} venceu há {{DIAS}} dias ({{VENCIMENTO}}).\n\n',
//   paymentConfirmEnabled: false,
//   paymentConfirmSubject: 'Pagamento confirmado! ✅',
//   paymentConfirmMessage: 'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} foi pago com sucesso.\n\nObrigado pela confiança!\n\nMensagem automática, favor não responder.',
// };

// // ══════════════════════════════════════════════════════
// // SUB-COMPONENTES
// // ══════════════════════════════════════════════════════
// function ToggleSwitch({ enabled, onChange }: { enabled: boolean; onChange: (val: boolean) => void }) {
//   return (
//     <Form.Check
//       type="switch"
//       checked={enabled}
//       onChange={(e) => onChange(e.target.checked)}
//       className="fs-5 mb-0"
//     />
//   );
// }

// function VariablesInfo() {
//   const [open, setOpen] = useState(true);
//   return (
//     <div className="mb-2">
//       <Button
//         variant="outline-secondary"
//         size="sm"
//         onClick={() => setOpen(o => !o)}
//         className="d-flex align-items-center gap-2"
//       >
//         <FaInfoCircle />
//         {open ? 'Ocultar variáveis' : 'Variáveis disponíveis'}
//       </Button>

//       {open && (
//         <div className="mt-2 p-3 bg-light rounded border">
//           <p className="mb-2 small fw-semibold text-muted">
//             💡 Clique em uma variável para copiar — use no <strong>assunto</strong> ou na <strong>mensagem</strong>:
//           </p>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
//             {VARIABLES.map(v => (
//               <button
//                 key={v.key}
//                 type="button"
//                 onClick={() => {
//                   navigator.clipboard.writeText(v.key);
//                   toast.info(`Copiado: ${v.key}`, { autoClose: 1500 });
//                 }}
//                 style={{
//                   display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
//                   background: '#fff', border: '1px solid #dee2e6', borderRadius: '8px',
//                   padding: '6px 12px', cursor: 'pointer', transition: 'all 0.15s', minWidth: '130px',
//                 }}
//                 onMouseEnter={e => {
//                   (e.currentTarget as HTMLButtonElement).style.borderColor = '#0d6efd';
//                   (e.currentTarget as HTMLButtonElement).style.background  = '#f0f4ff';
//                 }}
//                 onMouseLeave={e => {
//                   (e.currentTarget as HTMLButtonElement).style.borderColor = '#dee2e6';
//                   (e.currentTarget as HTMLButtonElement).style.background  = '#fff';
//                 }}
//               >
//                 <span style={{ fontFamily: 'monospace', fontSize: '0.78rem', fontWeight: 700, color: '#0d6efd' }}>
//                   {v.key}
//                 </span>
//                 <span style={{ fontSize: '0.7rem', color: '#6c757d', marginTop: '1px' }}>
//                   {v.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//           <p className="mb-0 mt-3 small text-muted border-top pt-2">
//             ℹ️ As variáveis acima funcionam tanto no <strong>assunto</strong> quanto no <strong>corpo</strong> da mensagem.
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }

// function NotificationSection({
//   title, icon, color, enabled, onToggle, onReset, children,
// }: {
//   title:    string;
//   icon:     React.ReactNode;
//   color:    string;
//   enabled:  boolean;
//   onToggle: (val: boolean) => void;
//   onReset:  () => void;
//   children: React.ReactNode;
// }) {
//   return (
//     <Card className={`shadow-sm h-100 ${enabled ? `border-${color}` : ''}`}>
//       <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
//         <div className="d-flex align-items-center gap-2">
//           <span style={{ color: `var(--bs-${color})` }}>{icon}</span>
//           <div>
//             <h6 className="mb-0">{title}</h6>
//             <p className={`mb-0 small fw-semibold text-${enabled ? color : 'secondary'}`}>
//               {enabled ? '● Ativo' : '○ Inativo'}
//             </p>
//           </div>
//         </div>
//         <div className="d-flex align-items-center gap-2">
//           <Button
//             variant="outline-secondary" size="sm" type="button"
//             title="Resetar para o padrão"
//             onClick={() => {
//               if (window.confirm(`⚠️ Resetar "${title}" para o padrão?`)) {
//                 onReset();
//                 toast.info(`"${title}" resetado para o padrão.`);
//               }
//             }}
//           >
//             <FaUndo />
//           </Button>
//           <ToggleSwitch enabled={enabled} onChange={onToggle} />
//         </div>
//       </Card.Header>
//       {enabled && <Card.Body>{children}</Card.Body>}
//     </Card>
//   );
// }

// // ══════════════════════════════════════════════════════
// // COMPONENTE PRINCIPAL
// // ══════════════════════════════════════════════════════
// export default function PainelEmail() {
//   const [loading, setLoading] = useState(true);
//   const [saving,  setSaving]  = useState(false);
//   const [testing, setTesting] = useState(false);
//   const [preview, setPreview] = useState<PreviewItem[]>([]);
//   const [config,  setConfig]  = useState<EmailConfig>(INITIAL_CONFIG);
//   const [showSmtpPassword, setShowSmtpPassword] = useState(false);

//   useEffect(() => {
//     (async () => {
//       try {
//         const { data } = await api.get('/email/config');
//         setConfig(prev => ({ ...prev, ...data }));
//       } catch (error) {
//         console.error('[Email Config] Erro ao carregar:', error);
//         toast.error('Erro ao carregar configurações de e-mail.');
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   const set = useCallback(
//     <K extends keyof EmailConfig>(key: K, value: EmailConfig[K]) => {
//       setConfig(prev => ({ ...prev, [key]: value }));
//     }, []
//   );

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value, type } = e.target;
//     const checked = (e.target as HTMLInputElement).checked;
//     setConfig(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value,
//     }));
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!config.smtpHost || !config.smtpUser || !config.smtpPassword) {
//       toast.warning('Preencha as configurações de SMTP antes de salvar.');
//       return;
//     }
//     if (config.delayMinSeconds >= config.delayMaxSeconds) {
//       toast.warning('O delay mínimo deve ser menor que o delay máximo.');
//       return;
//     }
//     if (config.beforeDueEnabled && config.beforeDueDaysMin > config.beforeDueDaysMax) {
//       toast.warning('"Antes do vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
//       return;
//     }
//     if (config.afterDueEnabled && config.afterDueDaysMin > config.afterDueDaysMax) {
//       toast.warning('"Após vencimento": o dia mínimo deve ser menor que o máximo.');
//       return;
//     }

//     try {
//       setSaving(true);
//       await api.put('/email/config', config);
//       toast.success('Configurações de e-mail salvas com sucesso!');
//     } catch (error: unknown) {
//       const err = error as { response?: { data?: { error?: string } } };
//       toast.error(err.response?.data?.error || 'Erro ao salvar configurações.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleTestRun = async (dryRun: boolean) => {
//     try {
//       setTesting(true);
//       setPreview([]);

//       const { data } = await api.post('/email/test-run', { dryRun });

//       if (data.total === 0) {
//         toast.info('Nenhuma notificação de e-mail pendente para hoje.');
//         return;
//       }

//       if (dryRun) {
//         setPreview(data.data ?? []);
//         toast.info(`${data.total} e-mail(s) encontrado(s). Veja o preview abaixo.`);
//       } else {
//         toast.success(data.message);
//       }
//     } catch (err: unknown) {
//       const e = err as { response?: { data?: { error?: string } } };
//       toast.error(e.response?.data?.error || 'Erro ao executar teste.');
//     } finally {
//       setTesting(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center mt-5 pt-5">
//         <Spinner animation="border" variant="primary" />
//         <div className="mt-2 text-muted">Carregando configurações de e-mail...</div>
//       </div>
//     );
//   }

//   return (
//     <Container fluid className="p-4">

//       {/* ── Cabeçalho ── */}
//       <div className="mb-4">
//         <h1 className="mb-0 d-flex align-items-center gap-2">
//           <FaEnvelope className="text-primary" />
//           Painel de E-mail
//         </h1>
//         <small className="text-muted">Configurações de notificações automáticas de cobrança por e-mail</small>
//       </div>

//       <Form onSubmit={handleSubmit}>
//         <div className="d-flex flex-column gap-4">

//           {/* ── Variáveis ── */}
//           <VariablesInfo />

//           {/* ══════════════════════════════════════
//               BLOCO SMTP
//           ══════════════════════════════════════ */}
//           <Card className="shadow-sm border-primary border-opacity-50">
//             <Card.Header className="bg-white d-flex align-items-center gap-2 py-3">
//               <FaServer className="text-primary fs-5" />
//               <div>
//                 <h6 className="mb-0">Configuração do Servidor SMTP</h6>
//                 <p className="mb-0 small text-muted">Credenciais para envio de e-mails</p>
//               </div>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-3">

//                 <Col md={5}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Servidor SMTP</Form.Label>
//                     <Form.Control
//                       type="text" name="smtpHost"
//                       value={config.smtpHost} onChange={handleChange}
//                       placeholder="smtp.gmail.com"
//                     />
//                     <Form.Text className="text-muted">Ex: smtp.gmail.com, smtp.outlook.com</Form.Text>
//                   </Form.Group>
//                 </Col>

//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Porta</Form.Label>
//                     <Form.Control
//                       type="number" name="smtpPort"
//                       value={config.smtpPort} onChange={handleChange}
//                       min={1} max={65535}
//                     />
//                     <Form.Text className="text-muted">587 ou 465</Form.Text>
//                   </Form.Group>
//                 </Col>

//                 <Col md={5}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Usuário (e-mail de login)</Form.Label>
//                     <Form.Control
//                       type="email" name="smtpUser"
//                       value={config.smtpUser} onChange={handleChange}
//                       placeholder="seuemail@gmail.com"
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={4}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">
//                       <FaLock className="me-1 text-muted" />
//                       Senha / App Password
//                     </Form.Label>
//                     <div className="input-group">
//                       <Form.Control
//                         type={showSmtpPassword ? 'text' : 'password'}
//                         name="smtpPassword"
//                         value={config.smtpPassword} onChange={handleChange}
//                         placeholder="••••••••••••"
//                       />
//                       <Button
//                         variant="outline-secondary"
//                         type="button"
//                         onClick={() => setShowSmtpPassword(p => !p)}
//                       >
//                         {showSmtpPassword ? '🙈' : '👁️'}
//                       </Button>
//                     </div>
//                     <Form.Text className="text-muted">
//                       Gmail: use uma <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noreferrer">senha de app</a>
//                     </Form.Text>
//                   </Form.Group>
//                 </Col>

//                 <Col md={4}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Nome do Remetente</Form.Label>
//                     <Form.Control
//                       type="text" name="smtpFromName"
//                       value={config.smtpFromName} onChange={handleChange}
//                       placeholder="Minha Empresa"
//                     />
//                     <Form.Text className="text-muted">Aparece como "De:" no e-mail</Form.Text>
//                   </Form.Group>
//                 </Col>

//                 <Col md={4}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">E-mail do Remetente</Form.Label>
//                     <Form.Control
//                       type="email" name="smtpFromEmail"
//                       value={config.smtpFromEmail} onChange={handleChange}
//                       placeholder="noreply@minhaempresa.com"
//                     />
//                     <Form.Text className="text-muted">Pode ser diferente do usuário SMTP</Form.Text>
//                   </Form.Group>
//                 </Col>

//               </Row>

//               {/* Dica SSL */}
//               <div className="alert alert-info py-2 small mt-3 mb-0 d-flex align-items-center gap-2">
//                 <FaInfoCircle />
//                 <span>
//                   Use a porta <strong>587</strong> com STARTTLS (padrão) ou <strong>465</strong> com SSL.
//                   O sistema detecta automaticamente com base na porta configurada.
//                 </span>
//               </div>
//             </Card.Body>
//           </Card>

//           {/* ══════════════════════════════════════
//               BLOCO — ENVIO EM LOTE
//           ══════════════════════════════════════ */}
//           <Card className={`shadow-sm ${config.batchSendEnabled ? 'border-primary' : ''}`}>
//             <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
//               <div className="d-flex align-items-center gap-2">
//                 <FaCog className="text-primary fs-5" />
//                 <div>
//                   <h6 className="mb-0">Configuração de Envio em Lote</h6>
//                   <p className={`mb-0 small fw-semibold text-${config.batchSendEnabled ? 'primary' : 'secondary'}`}>
//                     {config.batchSendEnabled ? '● Ativo' : '○ Inativo'}
//                   </p>
//                 </div>
//               </div>
//               <ToggleSwitch enabled={config.batchSendEnabled} onChange={v => set('batchSendEnabled', v)} />
//             </Card.Header>

//             {config.batchSendEnabled && (
//               <Card.Body>
//                 <p className="text-muted small mb-4">
//                   Ativa o envio automático e em massa de e-mails. Configure o horário e o intervalo entre os envios.
//                 </p>
//                 <Row className="g-3">
//                   <Col md={4}>
//                     <Card className="bg-light border-0 p-3 h-100">
//                       <div className="d-flex align-items-center gap-2 mb-3">
//                         <FaClock className="text-primary" />
//                         <strong>Horário de Envio</strong>
//                       </div>
//                       <Row>
//                         <Col>
//                           <Form.Group>
//                             <Form.Label className="small">Hora</Form.Label>
//                             <Form.Control
//                               type="number" name="sendHour"
//                               value={config.sendHour} onChange={handleChange}
//                               min={0} max={23}
//                             />
//                           </Form.Group>
//                         </Col>
//                         <Col>
//                           <Form.Group>
//                             <Form.Label className="small">Minuto</Form.Label>
//                             <Form.Control
//                               type="number" name="sendMinute"
//                               value={config.sendMinute} onChange={handleChange}
//                               min={0} max={59}
//                             />
//                           </Form.Group>
//                         </Col>
//                       </Row>
//                       <small className="text-muted mt-2">
//                         Envio diário às{' '}
//                         <strong>
//                           {String(config.sendHour).padStart(2, '0')}:
//                           {String(config.sendMinute).padStart(2, '0')}h
//                         </strong>
//                       </small>
//                     </Card>
//                   </Col>
//                   <Col md={8}>
//                     <Card className="bg-light border-0 p-3 h-100">
//                       <div className="d-flex align-items-center gap-2 mb-3">
//                         <FaClock className="text-warning" />
//                         <strong>Intervalo Aleatório entre Envios</strong>
//                       </div>
//                       <Row>
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label className="small">Mínimo (segundos)</Form.Label>
//                             <Form.Control
//                               type="number" name="delayMinSeconds"
//                               value={config.delayMinSeconds} onChange={handleChange}
//                               min={1} max={300}
//                             />
//                           </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label className="small">Máximo (segundos)</Form.Label>
//                             <Form.Control
//                               type="number" name="delayMaxSeconds"
//                               value={config.delayMaxSeconds} onChange={handleChange}
//                               min={1} max={300}
//                             />
//                           </Form.Group>
//                         </Col>
//                       </Row>
//                       <small className="text-muted mt-2">
//                         Aguarda entre <strong>{config.delayMinSeconds}s</strong> e{' '}
//                         <strong>{config.delayMaxSeconds}s</strong> entre cada e-mail.
//                       </small>
//                     </Card>
//                   </Col>
//                 </Row>
//               </Card.Body>
//             )}
//           </Card>

//           {/* ══════════════════════════════════════
//               BLOCOS — ANTES DO VENC. | VENCE HOJE
//           ══════════════════════════════════════ */}
//           <Row className="g-4">
//             <Col md={6}>
//               <NotificationSection
//                 title="Antes do Vencimento" icon={<FaBell />} color="warning"
//                 enabled={config.beforeDueEnabled} onToggle={v => set('beforeDueEnabled', v)}
//                 onReset={() => {
//                   set('beforeDueSubject', INITIAL_CONFIG.beforeDueSubject);
//                   set('beforeDueMessage', INITIAL_CONFIG.beforeDueMessage);
//                 }}
//               >
//                 <Row className="g-3 mb-3">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Até X dias antes</Form.Label>
//                       <Form.Control
//                         type="number" name="beforeDueDaysMax"
//                         value={config.beforeDueDaysMax} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Começar a enviar quando faltam. Ex: 30</Form.Text>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">No máximo X dias antes</Form.Label>
//                       <Form.Control
//                         type="number" name="beforeDueDaysMin"
//                         value={config.beforeDueDaysMin} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Parar de enviar quando faltam. Ex: 1</Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <div className="alert alert-warning py-2 small">
//                   Envia lembretes quando faltam entre <strong>{config.beforeDueDaysMax}</strong> e{' '}
//                   <strong>{config.beforeDueDaysMin}</strong> dia(s) para o vencimento.
//                 </div>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
//                   <Form.Control
//                     type="text" name="beforeDueSubject"
//                     value={config.beforeDueSubject} onChange={handleChange}
//                     placeholder="Ex: Lembrete: seu boleto vence em {{DIAS}} dias"
//                   />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="beforeDueMessage"
//                     value={config.beforeDueMessage} onChange={handleChange}
//                     placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>

//             <Col md={6}>
//               <NotificationSection
//                 title="Vence Hoje" icon={<FaBell />} color="primary"
//                 enabled={config.dueTodayEnabled} onToggle={v => set('dueTodayEnabled', v)}
//                 onReset={() => {
//                   set('dueTodaySubject', INITIAL_CONFIG.dueTodaySubject);
//                   set('dueTodayMessage', INITIAL_CONFIG.dueTodayMessage);
//                 }}
//               >
//                 <div className="alert alert-primary py-2 small mb-3">
//                   ℹ️ Enviado <strong>no dia do vencimento</strong>.
//                 </div>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
//                   <Form.Control
//                     type="text" name="dueTodaySubject"
//                     value={config.dueTodaySubject} onChange={handleChange}
//                     placeholder="Ex: Atenção: seu boleto vence hoje!"
//                   />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="dueTodayMessage"
//                     value={config.dueTodayMessage} onChange={handleChange}
//                     placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>
//           </Row>

//           {/* ══════════════════════════════════════
//               BLOCOS — APÓS VENC. | CONFIRMAÇÃO
//           ══════════════════════════════════════ */}
//           <Row className="g-4">
//             <Col md={6}>
//               <NotificationSection
//                 title="Após o Vencimento" icon={<FaBell />} color="danger"
//                 enabled={config.afterDueEnabled} onToggle={v => set('afterDueEnabled', v)}
//                 onReset={() => {
//                   set('afterDueSubject', INITIAL_CONFIG.afterDueSubject);
//                   set('afterDueMessage', INITIAL_CONFIG.afterDueMessage);
//                 }}
//               >
//                 <Row className="g-3 mb-3">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias após (mínimo)</Form.Label>
//                       <Form.Control
//                         type="number" name="afterDueDaysMin"
//                         value={config.afterDueDaysMin} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 1</Form.Text>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label className="small fw-semibold">Dias após (máximo)</Form.Label>
//                       <Form.Control
//                         type="number" name="afterDueDaysMax"
//                         value={config.afterDueDaysMax} onChange={handleChange}
//                         min={1} max={90}
//                       />
//                       <Form.Text className="text-muted">Ex: 15</Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <div className="alert alert-danger py-2 small">
//                   ⚠️ Enviado de <strong>{config.afterDueDaysMin}</strong> até{' '}
//                   <strong>{config.afterDueDaysMax}</strong> dia(s) após o vencimento.
//                 </div>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
//                   <Form.Control
//                     type="text" name="afterDueSubject"
//                     value={config.afterDueSubject} onChange={handleChange}
//                     placeholder="Ex: Boleto em atraso há {{DIAS}} dias"
//                   />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="afterDueMessage"
//                     value={config.afterDueMessage} onChange={handleChange}
//                     placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col>

//             {/* <Col md={6}>
//               <NotificationSection
//                 title="Confirmação de Pagamento" icon={<FaCheckCircle />} color="success"
//                 enabled={config.paymentConfirmEnabled} onToggle={v => set('paymentConfirmEnabled', v)}
//                 onReset={() => {
//                   set('paymentConfirmSubject', INITIAL_CONFIG.paymentConfirmSubject);
//                   set('paymentConfirmMessage', INITIAL_CONFIG.paymentConfirmMessage);
//                 }}
//               >
//                 <div className="alert alert-success py-2 small mb-3">
//                   ✅ Enviado automaticamente quando o pagamento é confirmado.
//                 </div>
//                 <Form.Group className="mb-3">
//                   <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
//                   <Form.Control
//                     type="text" name="paymentConfirmSubject"
//                     value={config.paymentConfirmSubject} onChange={handleChange}
//                     placeholder="Ex: Pagamento confirmado! ✅"
//                   />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
//                   <Form.Control
//                     as="textarea" rows={8} name="paymentConfirmMessage"
//                     value={config.paymentConfirmMessage} onChange={handleChange}
//                     placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
//                     style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
//                   />
//                 </Form.Group>
//               </NotificationSection>
//             </Col> */}
//           </Row>

//           {/* ══════════════════════════════════════
//               BOTÕES
//           ══════════════════════════════════════ */}
//           <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

//             <Button
//               variant="outline-secondary" type="button"
//               disabled={saving || testing}
//               onClick={() => {
//                 if (window.confirm('⚠️ Isso vai resetar TODAS as configurações para o padrão. Confirmar?')) {
//                   setConfig(INITIAL_CONFIG);
//                   toast.info('Todas as configurações resetadas para o padrão.');
//                 }
//               }}
//             >
//               <FaUndo className="me-2" />
//               Resetar Tudo
//             </Button>

//             <Button
//               variant="outline-info" type="button"
//               disabled={testing || saving}
//               onClick={() => handleTestRun(true)}
//             >
//               {testing
//                 ? <Spinner size="sm" animation="border" className="me-2" />
//                 : <FaEye className="me-2" />
//               }
//               Simular Envio
//             </Button>

//             <Button
//               variant="outline-warning" type="button"
//               disabled={testing || saving}
//               onClick={() => {
//                 if (window.confirm('⚠️ Isso vai enviar e-mails REAIS agora para os clientes. Confirmar?')) {
//                   handleTestRun(false);
//                 }
//               }}
//             >
//               {testing
//                 ? <Spinner size="sm" animation="border" className="me-2" />
//                 : <FaPlay className="me-2" />
//               }
//               Disparar Agora
//             </Button>

//             <Button variant="primary" type="submit" disabled={saving || testing} size="lg">
//               {saving
//                 ? <><Spinner size="sm" className="me-2" />Salvando...</>
//                 : <><FaSave className="me-2" />Salvar Configurações</>
//               }
//             </Button>
//           </div>

//           {/* ══════════════════════════════════════
//               PREVIEW — Dry Run
//           ══════════════════════════════════════ */}
//           {preview.length > 0 && (
//             <Card className="border-info shadow-sm">
//               <Card.Header className="bg-info bg-opacity-10 d-flex justify-content-between align-items-center">
//                 <strong className="d-flex align-items-center gap-2">
//                   <FaEye className="text-info" />
//                   Preview — {preview.length} e-mail(s) seriam enviados
//                 </strong>
//                 <Button size="sm" variant="outline-secondary" onClick={() => setPreview([])}>
//                   Fechar
//                 </Button>
//               </Card.Header>
//               <Card.Body className="p-0">
//                 <Table hover responsive className="mb-0 small">
//                   <thead className="table-light">
//                     <tr>
//                       <th style={{ width: '25%' }}>Cliente</th>
//                       <th style={{ width: '30%' }}>E-mail</th>
//                       <th>Assunto</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {preview.map((p, i) => (
//                       <tr key={i}>
//                         <td className="fw-semibold">{p.cliente}</td>
//                         <td><code>{p.email}</code></td>
//                         <td>{p.assunto}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           )}

//         </div>
//       </Form>
//     </Container>
//   );
// }

// src/pages/configuracoes/PainelEmail.tsx
import React, { useState, useEffect, useCallback } from 'react';
import {
  Container, Card, Button, Form,
  Row, Col, Spinner, Table
} from 'react-bootstrap';
import {
  FaSave, FaEnvelope, FaCog, FaClock,
  FaBell, FaCheckCircle, FaInfoCircle, FaPlay, FaEye, FaUndo, FaServer, FaLock,
  FaChevronDown, FaChevronUp,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';

// ══════════════════════════════════════════════════════
// TIPOS
// ══════════════════════════════════════════════════════
interface EmailConfig {
  batchSendEnabled:       boolean;
  sendHour:               number;
  sendMinute:             number;
  delayMinSeconds:        number;
  delayMaxSeconds:        number;
  // SMTP
  smtpHost:               string;
  smtpPort:               number;
  smtpUser:               string;
  smtpPassword:           string;
  smtpFromName:           string;
  smtpFromEmail:          string;
  // Flag do backend (masked secret)
  hasSmtpPassword?:       boolean;
  // Antes do vencimento
  beforeDueEnabled:       boolean;
  beforeDueDaysMin:       number;
  beforeDueDaysMax:       number;
  beforeDueSubject:       string;
  beforeDueMessage:       string;
  // Vence hoje
  dueTodayEnabled:        boolean;
  dueTodaySubject:        string;
  dueTodayMessage:        string;
  // Após vencimento
  afterDueEnabled:        boolean;
  afterDueDaysMin:        number;
  afterDueDaysMax:        number;
  afterDueSubject:        string;
  afterDueMessage:        string;
  // Confirmação
  paymentConfirmEnabled:  boolean;
  paymentConfirmSubject:  string;
  paymentConfirmMessage:  string;
}

interface PreviewItem {
  cliente: string;
  email:   string;
  assunto: string;
}

// ══════════════════════════════════════════════════════
// VARIÁVEIS DISPONÍVEIS
// ══════════════════════════════════════════════════════
const VARIABLES = [
  { key: '{{CLIENTE}}',         label: 'Nome do cliente'     },
  { key: '{{EMPRESA}}',         label: 'Nome da empresa'     },
  { key: '{{FATURA}}',          label: 'Descrição da fatura' },
  { key: '{{VENCIMENTO}}',      label: 'Data de vencimento'  },
  { key: '{{DIAS}}',            label: 'Quantidade de dias'  },
  { key: '{{VALOR_FATURA}}',    label: 'Valor da fatura'     },
  { key: '{{LINK_BOLETO}}',     label: 'Link do boleto'      },
  { key: '{{PIX_COPIA_COLA}}',  label: 'Pix copia e cola'    },
  { key: '{{LINHA_DIGITAVEL}}', label: 'Linha digitável'     },
];

// ══════════════════════════════════════════════════════
// ESTADO INICIAL
// ══════════════════════════════════════════════════════
const INITIAL_CONFIG: EmailConfig = {
  batchSendEnabled:      false,
  sendHour:              9,
  sendMinute:            0,
  delayMinSeconds:       10,
  delayMaxSeconds:       60,
  smtpHost:              'smtp.gmail.com',
  smtpPort:              587,
  smtpUser:              '',
  smtpPassword:          '',
  smtpFromName:          '',
  smtpFromEmail:         '',
  hasSmtpPassword:       false,
  beforeDueEnabled:      false,
  beforeDueDaysMin:      1,
  beforeDueDaysMax:      3,
  beforeDueSubject:      'Lembrete: seu boleto vence em {{DIAS}} dias',
  beforeDueMessage:      'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} vence em {{DIAS}} dias ({{VENCIMENTO}}).\n\n',
  dueTodayEnabled:       false,
  dueTodaySubject:       'Atenção: seu boleto vence hoje!',
  dueTodayMessage:       'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} vence hoje ({{VENCIMENTO}}).\n\n',
  afterDueEnabled:       false,
  afterDueDaysMin:       1,
  afterDueDaysMax:       15,
  afterDueSubject:       'Boleto em atraso há {{DIAS}} dias',
  afterDueMessage:       'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} venceu há {{DIAS}} dias ({{VENCIMENTO}}).\n\n',
  paymentConfirmEnabled: false,
  paymentConfirmSubject: 'Pagamento confirmado! ✅',
  paymentConfirmMessage: 'A {{EMPRESA}} informa: seu boleto referente ao {{FATURA}} foi pago com sucesso.\n\nObrigado pela confiança!\n\nMensagem automática, favor não responder.',
};

// Lista de campos considerados "mensagens" (para reset parcial)
const MESSAGE_FIELDS: (keyof EmailConfig)[] = [
  'batchSendEnabled', 'sendHour', 'sendMinute',
  'delayMinSeconds', 'delayMaxSeconds',
  'beforeDueEnabled', 'beforeDueDaysMin', 'beforeDueDaysMax',
  'beforeDueSubject', 'beforeDueMessage',
  'dueTodayEnabled', 'dueTodaySubject', 'dueTodayMessage',
  'afterDueEnabled', 'afterDueDaysMin', 'afterDueDaysMax',
  'afterDueSubject', 'afterDueMessage',
  'paymentConfirmEnabled', 'paymentConfirmSubject', 'paymentConfirmMessage',
];

// ══════════════════════════════════════════════════════
// SUB-COMPONENTES
// ══════════════════════════════════════════════════════
function ToggleSwitch({ enabled, onChange }: { enabled: boolean; onChange: (val: boolean) => void }) {
  return (
    <Form.Check
      type="switch"
      checked={enabled}
      onChange={(e) => onChange(e.target.checked)}
      className="fs-5 mb-0"
    />
  );
}

function VariablesInfo() {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-2">
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setOpen(o => !o)}
        className="d-flex align-items-center gap-2"
      >
        <FaInfoCircle />
        {open ? 'Ocultar variáveis' : 'Variáveis disponíveis'}
      </Button>

      {open && (
        <div className="mt-2 p-3 bg-light rounded border">
          <p className="mb-2 small fw-semibold text-muted">
            💡 Clique em uma variável para copiar — use no <strong>assunto</strong> ou na <strong>mensagem</strong>:
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {VARIABLES.map(v => (
              <button
                key={v.key}
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(v.key);
                  toast.info(`Copiado: ${v.key}`, { autoClose: 1500 });
                }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                  background: '#fff', border: '1px solid #dee2e6', borderRadius: '8px',
                  padding: '6px 12px', cursor: 'pointer', transition: 'all 0.15s', minWidth: '130px',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLButtonElement).style.borderColor = '#0d6efd';
                  (e.currentTarget as HTMLButtonElement).style.background  = '#f0f4ff';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLButtonElement).style.borderColor = '#dee2e6';
                  (e.currentTarget as HTMLButtonElement).style.background  = '#fff';
                }}
              >
                <span style={{ fontFamily: 'monospace', fontSize: '0.78rem', fontWeight: 700, color: '#0d6efd' }}>
                  {v.key}
                </span>
                <span style={{ fontSize: '0.7rem', color: '#6c757d', marginTop: '1px' }}>
                  {v.label}
                </span>
              </button>
            ))}
          </div>
          <p className="mb-0 mt-3 small text-muted border-top pt-2">
            ℹ️ As variáveis acima funcionam tanto no <strong>assunto</strong> quanto no <strong>corpo</strong> da mensagem.
          </p>
        </div>
      )}
    </div>
  );
}

function NotificationSection({
  title, icon, color, enabled, onToggle, onReset, children,
}: {
  title:    string;
  icon:     React.ReactNode;
  color:    string;
  enabled:  boolean;
  onToggle: (val: boolean) => void;
  onReset:  () => void;
  children: React.ReactNode;
}) {
  return (
    <Card className={`shadow-sm h-100 ${enabled ? `border-${color}` : ''}`}>
      <Card.Header className="bg-white d-flex align-items-center justify-content-between py-3">
        <div className="d-flex align-items-center gap-2">
          <span style={{ color: `var(--bs-${color})` }}>{icon}</span>
          <div>
            <h6 className="mb-0">{title}</h6>
            <p className={`mb-0 small fw-semibold text-${enabled ? color : 'secondary'}`}>
              {enabled ? '● Ativo' : '○ Inativo'}
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="outline-secondary" size="sm" type="button"
            title="Resetar para o padrão"
            onClick={() => {
              if (window.confirm(`⚠️ Resetar "${title}" para o padrão?`)) {
                onReset();
                toast.info(`"${title}" resetado para o padrão.`);
              }
            }}
          >
            <FaUndo />
          </Button>
          <ToggleSwitch enabled={enabled} onChange={onToggle} />
        </div>
      </Card.Header>
      {enabled && <Card.Body>{children}</Card.Body>}
    </Card>
  );
}

// ══════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL
// ══════════════════════════════════════════════════════
export default function PainelEmail() {
  const [loading,          setLoading]          = useState(true);
  const [savingSmtp,       setSavingSmtp]       = useState(false);
  const [savingMsgs,       setSavingMsgs]       = useState(false);
  const [testing,          setTesting]          = useState(false);
  const [preview,          setPreview]          = useState<PreviewItem[]>([]);
  const [config,           setConfig]           = useState<EmailConfig>(INITIAL_CONFIG);
  const [showSmtpPassword, setShowSmtpPassword] = useState(false);
  const [smtpOpen,         setSmtpOpen]         = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/email/config');
        setConfig(prev => ({ ...prev, ...data }));

        // Se NÃO tem SMTP configurado, abre automaticamente
        setSmtpOpen(!data.hasSmtpPassword);

      } catch (error) {
        console.error('[Email Config] Erro ao carregar:', error);
        toast.error('Erro ao carregar configurações de e-mail.');
        setSmtpOpen(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const set = useCallback(
    <K extends keyof EmailConfig>(key: K, value: EmailConfig[K]) => {
      setConfig(prev => ({ ...prev, [key]: value }));
    }, []
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value,
    }));
  };

  // ═══════════════════════════════════════════
  // SALVA APENAS SMTP
  // ═══════════════════════════════════════════
  const handleSaveSmtp = async () => {
    if (!config.smtpHost || !config.smtpUser) {
      toast.warning('Preencha host e usuário SMTP antes de salvar.');
      return;
    }
    if (!config.hasSmtpPassword && !config.smtpPassword.trim()) {
      toast.warning('Informe a senha/App Password do SMTP.');
      return;
    }

    try {
      setSavingSmtp(true);

      const payload: Record<string, any> = {
        smtpHost:      config.smtpHost,
        smtpPort:      config.smtpPort,
        smtpUser:      config.smtpUser,
        smtpFromName:  config.smtpFromName,
        smtpFromEmail: config.smtpFromEmail,
      };

      // Só envia senha se foi preenchida (preserva a atual se vazio)
      if (config.smtpPassword.trim()) {
        payload.smtpPassword = config.smtpPassword;
      }

      await api.put('/email/config', payload);
      toast.success('Configurações SMTP salvas!');

      // Recarrega pra atualizar hasSmtpPassword e limpar o campo senha
      const { data } = await api.get('/email/config');
      setConfig(prev => ({ ...prev, ...data }));

      // Fecha o card após salvar com sucesso
      setSmtpOpen(false);

    } catch (error: unknown) {
      const err = error as { response?: { data?: { error?: string } } };
      toast.error(err.response?.data?.error || 'Erro ao salvar SMTP.');
    } finally {
      setSavingSmtp(false);
    }
  };

  // ═══════════════════════════════════════════
  // SALVA APENAS MENSAGENS
  // ═══════════════════════════════════════════
  const handleSaveMessages = async (e: React.FormEvent) => {
    e.preventDefault();

    if (config.delayMinSeconds >= config.delayMaxSeconds) {
      toast.warning('O delay mínimo deve ser menor que o delay máximo.');
      return;
    }
    if (config.beforeDueEnabled && config.beforeDueDaysMin > config.beforeDueDaysMax) {
      toast.warning('"Antes do vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
      return;
    }
    if (config.afterDueEnabled && config.afterDueDaysMin > config.afterDueDaysMax) {
      toast.warning('"Após vencimento": o dia mínimo deve ser menor ou igual ao máximo.');
      return;
    }

    try {
      setSavingMsgs(true);

      // Remove campos SMTP e flags do payload
      const {
        smtpHost, smtpPort, smtpUser, smtpPassword,
        smtpFromName, smtpFromEmail, hasSmtpPassword,
        ...messagesData
      } = config;

      await api.put('/email/config', messagesData);
      toast.success('Mensagens salvas com sucesso!');

    } catch (error: unknown) {
      const err = error as { response?: { data?: { error?: string } } };
      toast.error(err.response?.data?.error || 'Erro ao salvar mensagens.');
    } finally {
      setSavingMsgs(false);
    }
  };

  const handleTestRun = async (dryRun: boolean) => {
    try {
      setTesting(true);
      setPreview([]);

      const { data } = await api.post('/email/test-run', { dryRun });

      if (data.total === 0) {
        toast.info('Nenhuma notificação de e-mail pendente para hoje.');
        return;
      }

      if (dryRun) {
        setPreview(data.data ?? []);
        toast.info(`${data.total} e-mail(s) encontrado(s). Veja o preview abaixo.`);
      } else {
        toast.success(data.message);
      }
    } catch (err: unknown) {
      const e = err as { response?: { data?: { error?: string } } };
      toast.error(e.response?.data?.error || 'Erro ao executar teste.');
    } finally {
      setTesting(false);
    }
  };

  // Reset apenas das mensagens (mantém SMTP)
  const handleResetMessages = () => {
    if (!window.confirm('⚠️ Isso vai resetar TODAS as mensagens para o padrão. Confirmar?')) {
      return;
    }
    setConfig(prev => {
      const updated = { ...prev };
      MESSAGE_FIELDS.forEach(field => {
        (updated as any)[field] = INITIAL_CONFIG[field];
      });
      return updated;
    });
    toast.info('Mensagens resetadas para o padrão.');
  };

  if (loading) {
    return (
      <div className="text-center mt-5 pt-5">
        <Spinner animation="border" variant="primary" />
        <div className="mt-2 text-muted">Carregando configurações de e-mail...</div>
      </div>
    );
  }

  return (
    <Container fluid className="p-4">

      {/* ── Cabeçalho ── */}
      <div className="mb-4">
        <h1 className="mb-0 d-flex align-items-center gap-2">
          <FaEnvelope className="text-primary" />
          Painel de E-mail
        </h1>
        <small className="text-muted">Configurações de notificações automáticas de cobrança por e-mail</small>
      </div>

      <div className="d-flex flex-column gap-4">

        {/* ── Variáveis ── */}
        <VariablesInfo />

        {/* ══════════════════════════════════════
            BLOCO SMTP — colapsável, com botão próprio
        ══════════════════════════════════════ */}
        <Card className="shadow-sm border-primary border-opacity-50">
          <Card.Header
            className="bg-white d-flex align-items-center justify-content-between py-3"
            onClick={() => setSmtpOpen(o => !o)}
            style={{ cursor: 'pointer', userSelect: 'none' }}
          >
            <div className="d-flex align-items-center gap-2">
              <FaServer className="text-primary fs-5" />
              <div>
                <h6 className="mb-0 d-flex align-items-center gap-2">
                  Configuração do Servidor SMTP
                  {smtpOpen
                    ? <FaChevronUp   size={12} className="text-muted" />
                    : <FaChevronDown size={12} className="text-muted" />
                  }
                </h6>
                <p className="mb-0 small text-muted">Credenciais para envio de e-mails</p>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              {config.hasSmtpPassword ? (
                <span
                  className="d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: '#d1e7dd',
                    color:           '#0f5132',
                    border:          '1px solid #badbcc',
                    borderRadius:    12,
                    padding:         '3px 10px',
                    fontSize:        11,
                    fontWeight:      600,
                  }}
                >
                  <FaCheckCircle size={10} /> Configurado
                </span>
              ) : (
                <span
                  className="d-inline-flex align-items-center gap-1"
                  style={{
                    backgroundColor: '#fff3cd',
                    color:           '#664d03',
                    border:          '1px solid #ffecb5',
                    borderRadius:    12,
                    padding:         '3px 10px',
                    fontSize:        11,
                    fontWeight:      600,
                  }}
                >
                  ⚠️ Não configurado
                </span>
              )}
            </div>
          </Card.Header>

          {smtpOpen && (
            <Card.Body onClick={(e) => e.stopPropagation()}>
              <Row className="g-3">

                <Col md={5}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">Servidor SMTP</Form.Label>
                    <Form.Control
                      type="text" name="smtpHost"
                      value={config.smtpHost} onChange={handleChange}
                      placeholder="smtp.gmail.com"
                    />
                    <Form.Text className="text-muted">Ex: smtp.gmail.com, smtp.outlook.com</Form.Text>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">Porta</Form.Label>
                    <Form.Control
                      type="number" name="smtpPort"
                      value={config.smtpPort} onChange={handleChange}
                      min={1} max={65535}
                    />
                    <Form.Text className="text-muted">587 ou 465</Form.Text>
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">Usuário (e-mail de login)</Form.Label>
                    <Form.Control
                      type="email" name="smtpUser"
                      value={config.smtpUser} onChange={handleChange}
                      placeholder="seuemail@gmail.com"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold d-flex align-items-center justify-content-between">
                      <span>
                        <FaLock className="me-1 text-muted" />
                        Senha / App Password
                      </span>
                      {config.hasSmtpPassword && !config.smtpPassword && (
                        <span
                          className="d-inline-flex align-items-center gap-1"
                          style={{
                            backgroundColor: '#d1e7dd',
                            color:           '#0f5132',
                            border:          '1px solid #badbcc',
                            borderRadius:    10,
                            padding:         '2px 7px',
                            fontSize:        10,
                            fontWeight:      600,
                          }}
                        >
                          🔒 Salva
                        </span>
                      )}
                    </Form.Label>
                    <div className="input-group">
                      <Form.Control
                        type={showSmtpPassword ? 'text' : 'password'}
                        name="smtpPassword"
                        value={config.smtpPassword}
                        onChange={handleChange}
                        placeholder={
                          config.hasSmtpPassword
                            ? '••••••••  (deixe vazio p/ manter)'
                            : '••••••••••••'
                        }
                        autoComplete="new-password"
                        style={{
                          backgroundColor: config.hasSmtpPassword && !config.smtpPassword ? '#f0fdf4' : undefined,
                          borderColor:     config.hasSmtpPassword && !config.smtpPassword ? '#198754' : undefined,
                        }}
                      />
                      <Button
                        variant="outline-secondary"
                        type="button"
                        onClick={() => setShowSmtpPassword(p => !p)}
                      >
                        {showSmtpPassword ? '🙈' : '👁️'}
                      </Button>
                    </div>
                    <Form.Text className="text-muted">
                      {config.hasSmtpPassword
                        ? 'Digite uma nova senha apenas para substituir a atual.'
                        : <>Gmail: use uma <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noreferrer">senha de app</a></>
                      }
                    </Form.Text>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">Nome do Remetente</Form.Label>
                    <Form.Control
                      type="text" name="smtpFromName"
                      value={config.smtpFromName} onChange={handleChange}
                      placeholder="Minha Empresa"
                    />
                    <Form.Text className="text-muted">Aparece como "De:" no e-mail</Form.Text>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold">E-mail do Remetente</Form.Label>
                    <Form.Control
                      type="email" name="smtpFromEmail"
                      value={config.smtpFromEmail} onChange={handleChange}
                      placeholder="noreply@minhaempresa.com"
                    />
                    <Form.Text className="text-muted">Pode ser diferente do usuário SMTP</Form.Text>
                  </Form.Group>
                </Col>

              </Row>

              {/* Dica SSL */}
              <div className="alert alert-info py-2 small mt-3 mb-3 d-flex align-items-center gap-2">
                <FaInfoCircle />
                <span>
                  Use a porta <strong>587</strong> com STARTTLS (padrão) ou <strong>465</strong> com SSL.
                  O sistema detecta automaticamente com base na porta configurada.
                </span>
              </div>

              {/* Botão próprio do SMTP */}
              <div className="d-flex justify-content-end border-top pt-3">
                <Button
                  variant="primary"
                  type="button"
                  onClick={handleSaveSmtp}
                  disabled={savingSmtp || savingMsgs}
                >
                  {savingSmtp
                    ? <><Spinner size="sm" className="me-2" />Salvando SMTP...</>
                    : <><FaSave className="me-2" />Salvar SMTP</>
                  }
                </Button>
              </div>
            </Card.Body>
          )}
        </Card>

        {/* ══════════════════════════════════════
            FORM DAS MENSAGENS
        ══════════════════════════════════════ */}
        <Form onSubmit={handleSaveMessages}>
          <div className="d-flex flex-column gap-4">

            {/* ══════════════════════════════════════
                BLOCOS — ANTES DO VENC. | VENCE HOJE
            ══════════════════════════════════════ */}
            <Row className="g-4">
              <Col md={6}>
                <NotificationSection
                  title="Antes do Vencimento" icon={<FaBell />} color="warning"
                  enabled={config.beforeDueEnabled} onToggle={v => set('beforeDueEnabled', v)}
                  onReset={() => {
                    set('beforeDueSubject', INITIAL_CONFIG.beforeDueSubject);
                    set('beforeDueMessage', INITIAL_CONFIG.beforeDueMessage);
                  }}
                >
                  <Row className="g-3 mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Até X dias antes</Form.Label>
                        <Form.Control
                          type="number" name="beforeDueDaysMax"
                          value={config.beforeDueDaysMax} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Começar a enviar quando faltam. Ex: 30</Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">No máximo X dias antes</Form.Label>
                        <Form.Control
                          type="number" name="beforeDueDaysMin"
                          value={config.beforeDueDaysMin} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Parar de enviar quando faltam. Ex: 1</Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="alert alert-warning py-2 small">
                    Envia lembretes quando faltam entre <strong>{config.beforeDueDaysMax}</strong> e{' '}
                    <strong>{config.beforeDueDaysMin}</strong> dia(s) para o vencimento.
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
                    <Form.Control
                      type="text" name="beforeDueSubject"
                      value={config.beforeDueSubject} onChange={handleChange}
                      placeholder="Ex: Lembrete: seu boleto vence em {{DIAS}} dias"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="beforeDueMessage"
                      value={config.beforeDueMessage} onChange={handleChange}
                      placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>

              <Col md={6}>
                <NotificationSection
                  title="Vence Hoje" icon={<FaBell />} color="primary"
                  enabled={config.dueTodayEnabled} onToggle={v => set('dueTodayEnabled', v)}
                  onReset={() => {
                    set('dueTodaySubject', INITIAL_CONFIG.dueTodaySubject);
                    set('dueTodayMessage', INITIAL_CONFIG.dueTodayMessage);
                  }}
                >
                  <div className="alert alert-primary py-2 small mb-3">
                    ℹ️ Enviado <strong>no dia do vencimento</strong>.
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
                    <Form.Control
                      type="text" name="dueTodaySubject"
                      value={config.dueTodaySubject} onChange={handleChange}
                      placeholder="Ex: Atenção: seu boleto vence hoje!"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="dueTodayMessage"
                      value={config.dueTodayMessage} onChange={handleChange}
                      placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>
            </Row>

            {/* ══════════════════════════════════════
                BLOCO — APÓS VENCIMENTO
            ══════════════════════════════════════ */}
            <Row className="g-4">
              <Col md={6}>
                <NotificationSection
                  title="Após o Vencimento" icon={<FaBell />} color="danger"
                  enabled={config.afterDueEnabled} onToggle={v => set('afterDueEnabled', v)}
                  onReset={() => {
                    set('afterDueSubject', INITIAL_CONFIG.afterDueSubject);
                    set('afterDueMessage', INITIAL_CONFIG.afterDueMessage);
                  }}
                >
                  <Row className="g-3 mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias após (mínimo)</Form.Label>
                        <Form.Control
                          type="number" name="afterDueDaysMin"
                          value={config.afterDueDaysMin} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 1</Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="small fw-semibold">Dias após (máximo)</Form.Label>
                        <Form.Control
                          type="number" name="afterDueDaysMax"
                          value={config.afterDueDaysMax} onChange={handleChange}
                          min={1} max={90}
                        />
                        <Form.Text className="text-muted">Ex: 15</Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="alert alert-danger py-2 small">
                    ⚠️ Enviado de <strong>{config.afterDueDaysMin}</strong> até{' '}
                    <strong>{config.afterDueDaysMax}</strong> dia(s) após o vencimento.
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Assunto do E-mail</Form.Label>
                    <Form.Control
                      type="text" name="afterDueSubject"
                      value={config.afterDueSubject} onChange={handleChange}
                      placeholder="Ex: Boleto em atraso há {{DIAS}} dias"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="fw-semibold">Corpo do E-mail</Form.Label>
                    <Form.Control
                      as="textarea" rows={8} name="afterDueMessage"
                      value={config.afterDueMessage} onChange={handleChange}
                      placeholder="Digite o texto do e-mail. Use as variáveis disponíveis acima."
                      style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                    />
                  </Form.Group>
                </NotificationSection>
              </Col>
            </Row>

            {/* ══════════════════════════════════════
                BOTÕES DAS MENSAGENS
            ══════════════════════════════════════ */}
            <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

              <Button
                variant="outline-secondary" type="button"
                disabled={savingMsgs || testing}
                onClick={handleResetMessages}
              >
                <FaUndo className="me-2" />
                Resetar Mensagens
              </Button>

              <Button
                variant="outline-info" type="button"
                disabled={testing || savingMsgs}
                onClick={() => handleTestRun(true)}
              >
                {testing
                  ? <Spinner size="sm" animation="border" className="me-2" />
                  : <FaEye className="me-2" />
                }
                Simular Envio
              </Button>

              <Button
                variant="outline-warning" type="button"
                disabled={testing || savingMsgs}
                onClick={() => {
                  if (window.confirm('⚠️ Isso vai enviar e-mails REAIS agora para os clientes. Confirmar?')) {
                    handleTestRun(false);
                  }
                }}
              >
                {testing
                  ? <Spinner size="sm" animation="border" className="me-2" />
                  : <FaPlay className="me-2" />
                }
                Disparar Agora
              </Button>

              <Button variant="success" type="submit" disabled={savingMsgs || testing} size="lg">
                {savingMsgs
                  ? <><Spinner size="sm" className="me-2" />Salvando...</>
                  : <><FaSave className="me-2" />Salvar Mensagens</>
                }
              </Button>
            </div>

            {/* ══════════════════════════════════════
                PREVIEW — Dry Run
            ══════════════════════════════════════ */}
            {preview.length > 0 && (
              <Card className="border-info shadow-sm">
                <Card.Header className="bg-info bg-opacity-10 d-flex justify-content-between align-items-center">
                  <strong className="d-flex align-items-center gap-2">
                    <FaEye className="text-info" />
                    Preview — {preview.length} e-mail(s) seriam enviados
                  </strong>
                  <Button size="sm" variant="outline-secondary" onClick={() => setPreview([])}>
                    Fechar
                  </Button>
                </Card.Header>
                <Card.Body className="p-0">
                  <Table hover responsive className="mb-0 small">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '25%' }}>Cliente</th>
                        <th style={{ width: '30%' }}>E-mail</th>
                        <th>Assunto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {preview.map((p, i) => (
                        <tr key={i}>
                          <td className="fw-semibold">{p.cliente}</td>
                          <td><code>{p.email}</code></td>
                          <td>{p.assunto}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            )}

          </div>
        </Form>

      </div>
    </Container>
  );
}
